export enum GcpMetricDiscountMode {
  NoDiscount = 'no-discount',
  ApplyDiscountEqually = 'apply-discount-equally',
  ApplyDiscountIndividually = 'apply-discount-individually',
}
